import axios from './config';

const list = (params, successCb, errorCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/highlighted-links`, { params },
  ).then(
    res => successCb(res.data),
  ).catch(
    err => errorCb(err),
  );
};

const get = (id, successCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/highlighted-link/${id}`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.highlightedLink.get() received error from api request:', err),
  );
};

const post = (params, successCb, errorCb) => {
  if (params.highlightedLink.active === '1') {
    params.highlightedLink.active = true;
  }
  if (params.highlightedLink.active === '0') {
    params.highlightedLink.active = false;
  }

  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/highlighted-link`,
    params.highlightedLink,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const put = (params, successCb, errorCb) => {
  if (params.highlightedLink.active === '1') {
    params.highlightedLink.active = true;
  }
  if (params.highlightedLink.active === '0') {
    params.highlightedLink.active = false;
  }

  let { highlightedLink } = params;

  axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/highlighted-link/${params.id}`,
    highlightedLink,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const endpoints = {
  list,
  get,
  post,
  put,
};

export default endpoints;